document.addEventListener("DOMContentLoaded", function() {
    var items = document.querySelectorAll(".collection-view-options-container .collection-view-options-group .collection-view-options-item");

    var last_type = "";
    
    items.forEach(item => {
       item.addEventListener("click", function() {

         items.forEach(view_item => {
           view_item.classList.remove("active");
         });

         console.log(this.closest(".collection").querySelectorAll(".product-item"));

         this.classList.add("active");
         
         if(this.getAttribute("data-view") == "list") {
            this.closest(".collection").querySelectorAll(".product-item").forEach((pro_item, index) => {
             if(!pro_item.classList.contains("spp-item")) {
               if(pro_item.classList.contains("product-item--vertical")) {
                 pro_item.classList.remove("product-item--vertical");
                 last_type = "product-item--vertical";
               }else if(pro_item.classList.contains("product-item--horizontal")) {
                 pro_item.classList.remove("product-item--horizontal");
                 last_type = "product-item--horizontal";
               }
               pro_item.classList.add("product-item--list");
             }
            });
         }else {
            this.closest(".collection").querySelectorAll(".product-item").forEach((pro_item, index) => {
                if(!pro_item.classList.contains("spp-item")) {
                    if(last_type == "product-item--vertical") {
                        pro_item.classList.add("product-item--vertical");
                    }else if(last_type == "product-item--horizontal") {
                        pro_item.classList.add("product-item--horizontal");
                    }
                        pro_item.classList.remove("product-item--list");
                    }
            });
         }
       });
    });
 });